export default `
	mutation deleteTodo($todoId:ID!){
			deleteTodo(todoId:$todoId){
					todoId
			}
		}
	`